/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EconomicDetailResource } from './economicDetailResource';


export interface BrokerageOrderResource { 
    id: number;
    currency: BrokerageOrderResource.CurrencyEnum;
    name: string;
    image: string;
    sellPrice: number;
    reward: number;
    rewardType: string;
    rate: string;
    share: string;
    description: string;
    economicDetail: Array<EconomicDetailResource>;
}
export namespace BrokerageOrderResource {
    export type CurrencyEnum = 'Kč' | 'Eur';
    export const CurrencyEnum = {
        K: 'Kč' as CurrencyEnum,
        Eur: 'Eur' as CurrencyEnum
    };
}


